/* eslint-disable react/no-danger */
/* eslint-disable import/extensions */
import React, { useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { FaCheck, FaCircleInfo, FaCar, FaShieldHalved } from 'react-icons/fa6';
import { generator } from '@/helpers/index';
import { constant } from '@/helpers/constant';

export default function VehicleDataInfoComponent() {
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState('');
  const [detail, setDetail] = useState('');

  const handleDetail = (value) => {
    setTitle(value);
    setDetail(constant.inquiry.details.all[value] || '');
    setModalShow(true);
  };

  return (
    <Container fluid className="px-2 py-2">
      <div className="text-center mb-4 pt-2">
        <div className="badge bg-primary-subtle text-primary fw-semibold px-3 py-2 rounded-pill d-inline-flex align-items-center mb-2">
          <FaShieldHalved className="me-1" /> Dados Oficiais &amp; Verificados
        </div>
        <h2 className="header-3 oswald text-center text-dark mb-2">
          Informações disponíveis sobre qualquer veículo
        </h2>
        <p className="text-muted small mx-auto" style={{ maxWidth: '640px' }}>
          Confira todos os dados cadastrais, restrições e históricos retornados em nossas consultas.
          Clique em qualquer item para ver o detalhamento completo.
        </p>
      </div>

      <Row className="g-3 my-1">
        {constant.inquiry.items.vehicle.map((value) => (
          <Col xs={12} sm={6} lg={4} key={generator.token()}>
            <div
              role="button"
              tabIndex={0}
              className="vehicle-data-item-card"
              onClick={() => handleDetail(value)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleDetail(value); }}
            >
              <FaCheck className="vehicle-data-item-icon" />
              <div className="vehicle-data-item-content">
                <span className="vehicle-data-item-title">{value}</span>
                {constant.inquiry.details.warning[value] && (
                  <span className="vehicle-data-warning-badge">
                    {constant.inquiry.details.warning[value]}
                  </span>
                )}
              </div>
              <FaCircleInfo className="vehicle-data-info-icon" />
            </div>
          </Col>
        ))}
      </Row>

      {modalShow && (
        <Modal
          show
          onHide={() => setModalShow(false)}
          aria-labelledby="vehicle-detail-modal-title"
          centered
          className="vehicle-detail-modal"
        >
          <Modal.Header closeButton className="border-0 pb-1 pt-4 px-4">
            <Modal.Title id="vehicle-detail-modal-title" className="h4 oswald text-dark d-flex align-items-center gap-2 mb-0">
              <FaCar className="text-primary" />
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-2 px-4 pb-4">
            {constant.inquiry.details.warning[title] && (
              <div className="vehicle-data-warning-badge mb-3">
                {constant.inquiry.details.warning[title]}
              </div>
            )}
            <div
              className="vehicle-detail-body mb-4 text-secondary lh-base"
              dangerouslySetInnerHTML={{ __html: detail }}
            />
            <div className="text-end">
              <Button
                type="button"
                className="btn-gradient-primary rounded-pill px-4 py-2 fw-bold border-0 shadow-sm"
                onClick={() => setModalShow(false)}
              >
                Entendi
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </Container>
  );
}


